/* Dansk katalog for locale-invoice-live.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'actionApproval.approve': 'Godkend',
  'actionApproval.approveAction': 'Godkend: {action}',
  'live.reviewTitle': 'Gennemse fakturaen',
  'live.reviewInvoice': 'Kontrollér fakturaen nedenfor, før du godkender.',
  'live.deliveryLabel': 'Send som',
  'live.approveSend': 'Godkend og send',
  'live.approveIssue': 'Godkend og opret',
  'actionApproval.label.send_offer': 'Send tilbud',
  'actionApproval.label.send_credit_note': 'Send kreditnota',
  'actionApproval.label.send_reminder': 'Send betalingspåmindelse uden gebyr',
  'actionApproval.label.post_purchase': 'Registrer og bogfør køb',
  'actionApproval.label.reverse_purchase': 'Tilbagefør køb',
  'actionApproval.label.post_manual_voucher': 'Bogfør bilag',
  'actionApproval.label.reverse_voucher': 'Tilbagefør bilag',
  'actionApproval.label.approve_payroll_run': 'Godkend og bogfør lønkørsel',
  'actionApproval.label.reverse_payroll_run': 'Tilbagefør lønkørsel',
  'actionApproval.label.record_payroll_submission': 'Bekræft, at a-melding er indsendt uden for Plumme',
  'actionApproval.label.close_accounting_year': 'Godkend og luk regnskabsåret',
  'actionApproval.label.reopen_accounting_year': 'Genåbn regnskabsåret',
  'actionApproval.label.delete_invoice_drafts': 'Slet fakturakladder',
  'actionApproval.label.delete_purchase_draft': 'Slet købskladde',
  'actionApproval.label.delete_payroll_draft': 'Slet lønkladde',
  'actionApproval.label.delete_project': 'Slet projekt',
  'actionApproval.label.invite_business_member': 'Invitér bruger til virksomheden',
  'actionApproval.label.remove_business_member': 'Fjern brugerens adgang til virksomheden',
  'actionApproval.label.cancel_business_invite': 'Træk invitation tilbage',
  'live.reading': 'Læser formularen og vælger næste trin …',
  'live.open_editor': 'Åbner fakturaeditoren …',
  'live.set_layout': 'Skifter visning …',
  'live.set_customer': 'Vælger kunde …',
  'live.set_field': 'Udfylder felt …',
  'live.set_line': 'Udfylder fakturalinje …',
  'live.remove_line': 'Fjerner fakturalinje …',
  'live.open_customer_form': 'Klargør ny kunde …',
  'live.open_product_form': 'Klargør nyt produkt …',
  'live.review': 'Åbner forhåndsvisning …',
  'live.request_save': 'Klargør til godkendelse …',
  'live.finish': 'Kontrollerer resultatet …',
  'live.ask_user': 'Har brug for en afklaring …',
  'live.approval': 'Venter på, at du kontrollerer og gemmer formularen.',
  'live.customerApproval': 'Kontrollér den nye kunde i formularen. Når du gemmer, fortsætter jeg med fakturaen.',
  'live.productApproval': 'Kontrollér det nye produkt, prisen og momsen i formularen. Når du gemmer, fortsætter jeg med fakturaen.',
  'live.customerSaved': 'Kunden er gemt. Fortsætter med fakturaen.',
  'live.productSaved': 'Produktet er gemt. Fortsætter med fakturaen.',
  'live.cancelled': 'Oprettelsen er annulleret. Arbejdet med fakturaen er sat på pause.',
  'live.notApplied': 'Feltet blev ikke opdateret som forventet. Jeg er stoppet, så du kan kontrollere formularen.',
  'live.limit': 'Jeg har nået grænsen for antal trin. Kontrollér formularen, og beskriv, hvad der mangler.',
  'live.done.open_editor': 'Fakturaeditoren er åbnet.',
  'live.done.set_layout': 'Visningen er ændret.',
  'live.done.set_customer': 'Kunden er valgt.',
  'live.done.set_field': 'Feltet er udfyldt og kontrolleret.',
  'live.done.set_line': 'Fakturalinjen er udfyldt og kontrolleret.',
  'live.done.remove_line': 'Fakturalinjen er fjernet.',
  'control.productRequired': 'Produktet findes ikke i det aktive produktregister.',
  'control.intro': 'Fortæl, hvilken faktura du vil lave. Jeg udfylder formularen og kan oprette nødvendige kunder og produkter. Bed udtrykkeligt om at oprette og sende, når jeg skal færdiggøre fakturaen.',
  'live.create_customer': 'Gemmer kunden …',
  'live.create_product': 'Gemmer produktet …',
  'live.issue_invoice': 'Opretter fakturaen …',
  'live.send_invoice': 'Opretter og sender fakturaen …',
  'live.finished': 'Udfyldningen er færdig. Ændringerne er kontrolleret i fakturaformularen.',
  'live.clarification': 'Beskriv, hvad du vil gøre videre med fakturaen.',
  'live.invoiceIssued': 'Fakturaen er oprettet. Den er ikke sendt.',
  'live.invoiceSent': 'Fakturaen er sendt på e-mail.',
  'live.emailRequired': 'For at sende skal jeg bruge kundens e-mailadresse og afsenderens e-mail i virksomhedsindstillingerne. Angiv modtageradressen sammen med en ny anmodning om at sende.',
  'live.authorizationRequired': 'Skriv udtrykkeligt, hvad du vil oprette eller sende.',
  'live.deliveryUncertain': 'Afsendelse er allerede forsøgt. Kontrollér afsendelsesstatus i fakturalisten før et nyt forsøg, så kunden ikke får fakturaen to gange.',
  'live.deliveryNotSent': 'Fakturaen er oprettet, men afsendelsen blev ikke bekræftet. Kontrollér afsendelsesstatus i fakturalisten.',
  'live.ambiguousRecord': 'Flere kunder eller produkter har samme navn. Vælg den rigtige post først.',
  'live.actionBusy': 'En gemning eller afsendelse er allerede i gang.',
  'appControl.changed': 'Siden eller virksomheden er ændret. Kontrollér siden, og bed mig fortsætte.',
  'appControl.unsupported': 'Denne kontrol kræver, at du bruger den direkte på siden.',
  'appControl.authorization': 'Fortæl, hvilken handling du vil have mig til at udføre.',
  'appControl.manual': 'Fuldfør dette trin direkte på siden, så kan jeg fortsætte.',
  'appControl.option': 'Valget er ikke tilgængeligt i dette felt.',
  'appControl.repeated': 'Handlingen er allerede forsøgt. Kontrollér resultatet på siden, før du fortsætter.',
  'actionApproval.title': 'Godkend handling',
  'actionApproval.body': 'Kontrollér handlingen og oplysningerne nedenfor. Godkendelsen gælder kun dette trin.',
  'actionApproval.confirm': 'Godkend og udfør',
  'actionApproval.proposal': 'Foreslået handling',
  'actionApproval.context': 'Oplysninger, som handlingen vedrører',
  'actionApproval.cancel': 'Annuller',
  'actionApproval.mcp': 'Handling fra forbundet AI',
  'actionApproval.failed': 'Handlingen kunne ikke udføres. Hent et nyt forslag, og prøv igen.',
  'actionApproval.loading': 'Henter handlingen ...',
  'actionApproval.done': 'Handlingen er udført.',
  'actionApproval.business': 'Virksomhed',
  'actionApproval.writeScope': 'AI\'en kan foreslå skrivehandlinger. Hver handling skal godkendes af dig i Plumme, før den udføres.',
  'actionApproval.label.create_invoice_draft': 'Opret fakturakladde',
  'actionApproval.label.register_invoice_payment': 'Registrer fakturabetaling',
  'actionApproval.label.save_draft': 'Gem kladde',
  'actionApproval.label.send_invoice': 'Send faktura',
  'actionApproval.label.issue_invoice': 'Udsted faktura',
  'actionApproval.label.create_customer': 'Opret kunde',
  'actionApproval.label.create_product': 'Opret produkt',
  'actionApproval.label.invoice': 'Faktura',
  'actionApproval.label.invoiceId': 'Faktura-ID',
  'actionApproval.label.customer': 'Kunde',
  'actionApproval.label.customerName': 'Kundenavn',
  'actionApproval.label.currency': 'Valuta',
  'actionApproval.label.amount': 'Beløb',
  'actionApproval.label.date': 'Dato',
  'actionApproval.label.dueDate': 'Forfaldsdato',
  'actionApproval.label.lines': 'Linjer',
  'actionApproval.label.quantity': 'Antal',
  'actionApproval.label.unitPrice': 'Enhedspris',
  'actionApproval.label.vatRate': 'Momssats',
  'actionApproval.label.description': 'Beskrivelse',
  'actionApproval.label.business': 'Virksomhed',
  'actionApproval.label.expires': 'Gyldig til',
  'actionApproval.label.recipientEmail': 'Modtager',
  'actionApproval.label.fields': 'Felter',
  'actionApproval.label.label': 'Navn',
  'actionApproval.label.value': 'Værdi',
  'actionApproval.label.text': 'Oplysninger på siden',
  'actionApproval.label.action': 'Handling',
  'actionApproval.label.click': 'Tryk',
  'actionApproval.label.fill': 'Udfyld',
  'actionApproval.label.select': 'Vælg',
  'actionApproval.label.check': 'Skift valg',
  'actionApproval.label.checked': 'Valgt',
  'actionApproval.label.post': 'Bogfør',
  'actionApproval.label.approve': 'Godkend lønkørsel',
  'actionApproval.label.close_year': 'Godkend og luk regnskabsåret',
  'actionApproval.label.reopen_year': 'Genåbn regnskabsåret',
  'actionApproval.label.manage_members': 'Ændr adgange',
  'actionApproval.label.delete': 'Slet eller tilbagefør',
  'actionApproval.label.submit': 'Indsend',
  'actionApproval.label.expense': 'Køb',
  'actionApproval.label.supplier': 'Leverandør',
  'actionApproval.label.year': 'År',
  'actionApproval.label.records': 'Poster',
});
